import { Message } from "element-ui";

/**
 * 先关闭已有 Message 再展示一条，避免并发请求时同一条报错堆叠多条。
 * @param {string|object} options 字符串视为 error；对象同 Element Message 参数
 */
export function showSingleMessage(options) {
  Message.closeAll();
  if (typeof options === "string") {
    return Message({ message: options, type: "error" });
  }
  return Message(options);
}
